module.exports = new __parcel__URL__("army_tab_active.7d7f29c5.png").toString();